import { createGateValidate } from '../../application/dtos/create_gate_validate'

export class createGateEntity {
    constructor({name, is_entry, is_rfid, warehouse_id}){
        this.name = name;
        this.is_entry = is_entry;
        this.is_rfid = is_rfid;
        this.warehouse_id = warehouse_id;
    }

    isValid() {
        return createGateValidate(this);
    }
}